import { Grid, styled } from '@mui/material';

export const SummaryAssetImage = styled('img')(() => ({
  maxHeight: '150px'
}));

export const SummaryDeleteAsset = styled(Grid)(({ theme }) => ({
  position: 'relative',
  left: theme.spacing(3.5),
  width: 0
}));
